var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',[_c('v-tab',{attrs:{"to":{ name: 'currencies-payments' }}},[_vm._v("Couverture USD")]),_c('v-tab',{attrs:{"to":{ name: 'currencies-payments-history' }}},[_vm._v("Historique Paiements")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }